import { useLazyQuery } from "@apollo/client/react";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useCallback, useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { generateColumnsDefaultConfiguration } from "../../../../../components/dataGrid/columnHelpers";
import { adaptDocumentoById, GET_ARCHIVO_DOCUMENTO_ASISTENCIAL } from '../../../../../data/graphQL/queries/GestionAsistencial/getDocumentoById';
import { GET_PRINT_RESUMEN } from "../../../../../data/graphQL/queries/ResumenIngresoResumen/getPrintResumen";

export function useTabDocumentacionRI({ RIs, fetchHtml }) {
  const [fileToView, setFileToView] = useState();
  const [getDocumentoById] = useLazyQuery(GET_ARCHIVO_DOCUMENTO_ASISTENCIAL, {
    fetchPolicy: 'no-cache'
  });

  const [getPrintResumen, { data: dataPrintResumen, loading: loadingPrintResumen }] = useLazyQuery(GET_PRINT_RESUMEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataPrintResumen) return;
    if (dataPrintResumen.printResumenIngreso != null) {
      const arr = new Uint8Array(dataPrintResumen.printResumenIngreso);
      // const documento = new Blob([arr], { type: 'application/pdf' });
      // const fileName = `Resumen-Ingreso-${viewIdRI}.pdf`;
      return;
      // return {
      //   contentType: 'application/pdf',
      //   titulo: fileName,
      //   archivo: documento,
      //   extension: '.pdf'
      // };
    } else {
      toast.error('No se pudo exportar el Resumen, intentelo nuevamente más tarde.');
    }
  }, [dataPrintResumen]);


  const printReport = async (idRI, htmlRI) => {
    try {
      return await getPrintResumen({
        variables: {
          resumen: htmlRI,
          numeroRI: idRI,
          soloCP: document.getElementById('riSoloCP').innerHTML == "0" ? false : true
        }
      });
    } catch (error) {
      console.log(error);
      toast.error('No se pudo exportar el Resumen, intentelo nuevamente más tarde.');
    }
  };

  const [viewIdRI, setViewRI] = useState(0);
  const handleClickView = useCallback(
    async (row) => {
      try {
        const idRI = row?.datos?.match(/Detalle del RI: (\d+)/)?.[1];
        if (!!idRI && !isNaN(idRI)) {
          setViewRI(idRI);
          const html = await fetchHtml({ idDatosGeneralesRI: idRI });
          // genero el PDF del RI
          const pdf = await printReport(idRI, html);
          setFileToView({
            archivo: pdf.data.printResumenIngreso,
            contentType: 'application/pdf',
            titulo: 'Resumen Ingreso ' + idRI,
            extension: '.pdf'
          });
        } else {
          const response = await getDocumentoById({
            variables: {
              idArchivo: row?.idArchivo,
              idTipoArchivoDocumento: row?.idTipoArchivoDocumento
            }
          });
          setFileToView(adaptDocumentoById(response?.data));
        }
      } catch (err) {
        console.error("Error al obtener el documento:", err);
      }
    },
    [fetchHtml]
  );

  const resetFileToView = () => setFileToView();

  const initialColumns = [
    { flex: 0.1, field: "Hidden", headerName: "", hide: true },
    {
      flex: 4,
      field: "profesional",
      headerName: "Profesional"
    },
    {
      flex: 2,
      field: "fechaAlta",
      headerName: "Fecha Alta"
    },
    {
      flex: 2,
      field: "referencia",
      headerName: "Referencia"
    },
    {
      flex: 2,
      field: "nroTalonario",
      headerName: "Nro. Talonario"
    },
    {
      headerName: "",
      field: "action",
      align: "center",
      flex: 1,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <div
            aria-hidden='true'
            onClick={() => handleClickView(row)}
            className="clickable-option">

            <AttachFileIcon className="edit-icon" sx={{ paddingTop: '5px' }} />
          </div>);

      }
    }];


  const columns = useMemo(
    () => generateColumnsDefaultConfiguration(initialColumns),
    [RIs]
  );

  return { columns, fileToView, resetFileToView };
}